import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const detect = () => {
  const saved = localStorage.getItem("s360-lang");
  if (saved && translations[saved]) return saved;
  const nav = (navigator.language || "en").toLowerCase();
  const prefix = nav.split("-")[0];
  return translations[prefix] ? prefix : "en";
};

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: translations.en });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detect);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("s360-lang", l);
    setLangState(l);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
